module.exports = __webpack_public_path__ + "static/media/17.76f893f4.jpg";